// Disable CSS transition while the page is loading

// Styles
require("./disable-transition-onload.scss");

// JavaScript
var $ = require("jquery");
$(window).load(function () {
    $("body").removeClass("disable-transition");
});


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/disable-transition-onload/index.js
 ** module id = 43
 ** module chunks = 0 1
 **/